import UnassignDetailDialog from "./unassignDetailDialog.container";

export default UnassignDetailDialog;
